import { Injectable } from '@angular/core';
import { getAuth } from '@angular/fire/auth';
import { collection, doc, Firestore, query, limit, orderBy, where, getDoc, getDocs, startAfter, endBefore, limitToLast, serverTimestamp, updateDoc, setDoc, collectionGroup, deleteDoc, QueryConstraint } from '@angular/fire/firestore';
import { getFunctions, httpsCallable } from "@angular/fire/functions"
import { MatSnackBar } from '@angular/material/snack-bar';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { UserService } from './user.service';
import { AccessesService } from './accesses.service';
import { HelperService } from './helper.service';
import { ProjectSettingsService } from './project-settings.service';
import { UserSettingsService } from './user-settings.service';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  tsvUploaded:any = ''
  public projectDetails: any;
  public unsavedChanges: any;
  public isaccessgiven: any;
  public sandboxData: any = []
  public deletingProjetId: any;
  public oldQuestionDetails: any;
  pdfLetestDT:any;
  selfCheckQuestion: any
  mergeQuizMap: any = {}
  questionCategory: any = [
    {
      "categoryDescription": "S1:Standard",
      "categoryId": 48
    },
    {
      "categoryDescription": "S2:Premium",
      "categoryId": 49
    },
    {
      "categoryDescription": "S3:General Knowledge",
      "categoryId": 50
    },


    {
      "categoryDescription": "Physics",
      "categoryId": 1
    },
    {
      "categoryId": 10,
      "categoryDescription": "History"
    },
    {
      "categoryDescription": "Language",
      "categoryId": 11
    },
    {
      "categoryDescription": "Technology",
      "categoryId": 12
    },
    {
      "categoryDescription": "Books & Literature",
      "categoryId": 13
    },
    {
      "categoryDescription": "Art",
      "categoryId": 14
    },
    {
      "categoryDescription": "Music",
      "categoryId": 15
    },
    {
      "categoryDescription": "Films & Theatre",
      "categoryId": 16
    },
    {
      "categoryId": 17,
      "categoryDescription": "Football"
    },
    {
      "categoryId": 18,
      "categoryDescription": "Olympics"
    },
    {
      "categoryId": 19,
      "categoryDescription": "Cricket"
    },
    {
      "categoryId": 2,
      "categoryDescription": "Chemistry"
    },
    {
      "categoryId": 20,
      "categoryDescription": "Athletics"
    },
    {
      "categoryDescription": "Health & Fitness",
      "categoryId": 21
    },
    {
      "categoryDescription": "Food",
      "categoryId": 22
    },
    {
      "categoryId": 23,
      "categoryDescription": "Business"
    },
    {
      "categoryId": 24,
      "categoryDescription": "Earth & Nature"
    },
    {
      "categoryId": 25,
      "categoryDescription": "Sports"
    },
    {
      "categoryId": 26,
      "categoryDescription": "Entertainment"
    },
    {
      "categoryId": 27,
      "categoryDescription": "News"
    },
    {
      "categoryId": 28,
      "categoryDescription": "World travel"
    },
    {
      "categoryId": 29,
      "categoryDescription": "Incredible India"
    },
    {
      "categoryId": 3,
      "categoryDescription": "Mathematics"
    },
    {
      "categoryDescription": "General",
      "categoryId": 30
    },
    {
      "categoryId": 31,
      "categoryDescription": "Electric"
    },
    {
      "categoryId": 32,
      "categoryDescription": "Luxury"
    },
    {
      "categoryDescription": "Others",
      "categoryId": 33
    },
    {
      "categoryDescription": "Transportation",
      "categoryId": 4
    },
    {
      "categoryDescription": "Current Affairs",
      "categoryId": 5
    },
    {
      "categoryId": 6,
      "categoryDescription": "Religion"
    },
    {
      "categoryId": 7,
      "categoryDescription": "Geography"
    },
    {
      "categoryDescription": "Animal Kingdom",
      "categoryId": 8
    },
    {
      "categoryId": 9,
      "categoryDescription": "Human Body, Disease & Medicine"
    },
    {
      "categoryId": 34,
      "categoryDescription": "Army"
    },
    {
      "categoryId": 35,
      "categoryDescription": "Sci-Tech"
    },
    {
      "categoryId": 36,
      "categoryDescription": "Culture"
    },
    //below categories using only for 42dots.in
    {
      categoryDescription: "Business Mix",
      categoryId: 37,
      fieldId: "Business-Mix",
    },
    {
      categoryDescription: "Marketing & Sales",
      categoryId: 38,
      fieldId: "Marketing-and-Sales",
    },
    {
      categoryDescription: "Self-Development & Management Theory",
      categoryId: 39,
      fieldId: "Self-Development-and-Management-Theory",
    },
    {
      categoryDescription: "Leadership & Management",
      categoryId: 40,
      fieldId: "Leadership-and-Management",
    },
    {
      categoryDescription: "HR & Corporate Culture",
      categoryId: 41,
      fieldId: "HR-and-Corporate-Culture",
    },
    {
      categoryDescription: "Startups & Entrepreneurship",
      categoryId: 42,
      fieldId: "Startups-and-Entrepreneurship",
    },
    {
      categoryDescription: "Economics",
      categoryId: 43,
      fieldId: "Economics",
    },
    {
      categoryDescription: "Finance & Markets",
      categoryId: 44,
      fieldId: "Finance-and-Markets",
    },
    {
      categoryDescription: "Technology & Business",
      categoryId: 45,
      fieldId: "Technology-and-Business",
    },

    {
      "categoryId": 46,
      "categoryDescription": "Easy"
    },
    {
      "categoryId": 47,
      "categoryDescription": "Hard"
    },
  ]
  private mergeQuizMapSubject = new Subject<any>();
  mergeQuizMap$: Observable<any> = this.mergeQuizMapSubject.asObservable();

  constructor(
    public firestore: Firestore,
    public cookieService: CookieService,
    private snackBar: MatSnackBar,
    private userService: UserService,
    private accessesService: AccessesService,
    private helperService: HelperService,
    private projectSetting: ProjectSettingsService,
    private userSettings: UserSettingsService,
    // private http: HttpClient
  ) { }

  public setSandboxData(v: any) {
    if (typeof (v) == 'object')
      this.sandboxData.push(v);
    else
      this.sandboxData = [];
  }

  public getSandboxData() {
    return this.sandboxData;
  }
  public setProjectDetails(v: any) {
    this.projectDetails = v;
  }

  public getProjectDetails() {
    return this.projectDetails;
  }

  public setDeletingProjectId(v: any) {
    this.deletingProjetId = v;
  }

  public getDeletingProjectId() {
    return this.deletingProjetId;
  }

  public setUnsavedChanges(v: any) {
    this.unsavedChanges = v;
  }

  public setAccess(access: any) {
    this.isaccessgiven = access;
  }

  public setTsvUploadDone(done:any) {
    this.tsvUploaded = done
  }

  public getTsvUploadDone() {
    return this.tsvUploaded
  }

  public getUnsavedChanges() {
    if (this.isaccessgiven)
      return this.unsavedChanges;
    else
      return false
  }

  public setPrevQuestions(question: any) {
    this.oldQuestionDetails = question
  }
  public getPrevQuestions() {
    return this.oldQuestionDetails
  }
  public getQuestionCategoryList() {
    return this.questionCategory
  }
  public isUnsavedTemplateProject() {
    let isUnsavedProject = false;
    if (this.cookieService.check('_un_sv_proj')) {
      let unsavedProjects = JSON.parse(this.cookieService.get('_un_sv_proj'));
      if (unsavedProjects && unsavedProjects.length) {
        let idx = unsavedProjects.indexOf(this.projectDetails.quizId ?? this.projectDetails.pollId)
        if (idx != -1) {
          isUnsavedProject = true;
        }
      }
    }
    return { isUnsavedProject, "projectDetails": this.projectDetails };
  }

  public removeUnsavedProjectFromCookie() {
    if (this.cookieService.check('_un_sv_proj')) {
      let unsavedProjects = JSON.parse(this.cookieService.get('_un_sv_proj'));
      if (unsavedProjects && unsavedProjects.length) {
        let idx = unsavedProjects.indexOf(this.projectDetails.quizId ?? this.projectDetails.pollId) //remove quizId/pollId cookie
        if (idx != -1) {
          unsavedProjects.splice(idx, 1);
          let unsavedProjectsStr = JSON.stringify(unsavedProjects);
          this.cookieService.set('_un_sv_proj', unsavedProjectsStr);
        }
      }
    }
  }

  //Delete unsavedQuiz
  public removeUnsavedTemplateProjectData() {
    return new Promise((resolve, reject) => {
      var deleteUnsavedTemplateQuiz = httpsCallable(getFunctions(), 'deleteUnsavedTemplateQuiz');
      deleteUnsavedTemplateQuiz(this.projectDetails).then((data) => {
        resolve(true)
      }).catch((err) => {
        reject(false)
      });
    })

  }

  //Delete unsavedPoll
  public removeUnsavedPollData() {
    return new Promise((resolve, reject) => {
      var deleteUnsavedPoll = httpsCallable(getFunctions(), 'deleteUnsavedPoll');
      deleteUnsavedPoll(this.projectDetails).then((data) => {
        resolve(true)
      }).catch((err) => {
        reject(false)
      });
    })

  }


  public async getQuizDetailsById(quizId: any, contentId: any = null) {
    return new Promise(async (resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      if (!contentId) {
        contentId = userContentRef.contentId
      }
      if (!quizId) {
        reject(null)
        return;
      }
      let quizRef = doc(this.firestore, 'contentAccountMapping', contentId, 'quiz', quizId)
      let quizDetails: any = null;
      await getDoc(quizRef).then((doc) => {
        quizDetails = doc.data();
        if (quizDetails)
          quizDetails.refContentId = contentId
        resolve(quizDetails)
      }).catch((err) => {
        quizDetails = null
        reject(err)
      });
    })
  }

  // =========CONTEST====== : contest function to check if someone already have an instance with the entered auth details.
  checkForContestDuplicateRegistration(projectSetting: any,selectedQuiz:any, _contestDetail: any, email: any, phone: any, name: any, seatNumber: any,personalSettings:any=null){
    return new Promise((resolve, reject) => {
      let contestRef = collection(this.firestore, 'contestInvitation')
      let contestDetails:any;
      if(_contestDetail.contestType == 'oneQuizPerContest'){
        contestDetails = query(contestRef, where('contestId', '==', _contestDetail.contestId))
      }else{
        contestDetails = query(contestRef, where('contestId', '==',_contestDetail.contestId),where('quizId', '==',selectedQuiz?.id))  
      }
      let responseDoc: any = {
        isDuplicate: false,
        email: false,
        phone: false,
        name: false,
        seatNumber: false
      }
      getDocs(contestDetails).then((docs: any) => {
        docs.forEach((doc: any) => {
          let contest: any = doc.data();
          // checking for duplicate email
          email = email?email.trim():''
          if (email != '' && email?.toLowerCase() == contest.email?.toLowerCase()) {
            responseDoc.email = true;
            if (projectSetting.regEmail) {
              responseDoc.isDuplicate = true;
            }
          }
          // checking for duplicate name
          name = name?name.trim():''
          if (name != '' && name?.toLowerCase() == contest.name?.trim()?.toLowerCase()) {
            if((personalSettings?.length == 1 && personalSettings[0] == 'name' && personalSettings!='resultPage')){
              responseDoc.name = true;
              if (projectSetting.regName) {
                responseDoc.isDuplicate = true;
              }
            }
            if(!email && !phone && !seatNumber && name && personalSettings=='resultPage'){
              responseDoc.name = true;
              if (projectSetting.regName) {
                responseDoc.isDuplicate = true;
              }
            }
          }
          // checking for duplicate phone
          if (phone != '' && phone == contest.phone) {
            responseDoc.phone = true;
            if (projectSetting.regPhoneNumber) {
              responseDoc.isDuplicate = true;
            }
          }
          // checking for duplicate seatnumber
          seatNumber = seatNumber?seatNumber.trim():''
          if (seatNumber != '' && seatNumber?.toLowerCase() == contest.seatNumber?.toLowerCase()) {
            responseDoc.seatNumber = true;
            if (projectSetting.regSeatNumber) {
              responseDoc.isDuplicate = true;
            }
          }
        })
        resolve(responseDoc)
      }).catch((err)=>{
        reject(err)
      })
    })
  }

  // function to check if someone already have an instance with the entered auth details.
  checkForDuplicateRegisteration(projectSetting: any, project: any, email: any, phone: any, name: any, seatNumber: any,liveId:any=null,personalSettings:any=null , _buzzerQuiz:any = null) {
    return new Promise((resolve, reject) => {
      let instancesId = collection(this.firestore, 'instances')
      let instancesDetails:any;
      if(liveId){
        instancesDetails = query(instancesId, where('liveQuizId', '==', liveId))
      }else if(_buzzerQuiz?.buzzerQuizId){
        instancesDetails = query(instancesId, where('buzzerQuizId', '==', _buzzerQuiz?.buzzerQuizId));
      }else{
        instancesDetails = query(instancesId, where('quiz', '==', project.quizId))
      }

      let responseDoc: any = {
        isDuplicate: false,
        email: false,
        phone: false,
        name: false,
        seatNumber: false
      }

      getDocs(instancesDetails).then((docs: any) => {
        docs.forEach((doc: any) => {

          let instance: any = doc.data();

          // checking for duplicate email
          email = email?email.trim():''
          if (email != '' && email?.toLowerCase() == instance.email?.toLowerCase() && project.refContentId!='Xy2NqqO8nPYI7YQFfETfr93GlkG3') {
            responseDoc.email = true;
            if (projectSetting.regEmail) {
              responseDoc.isDuplicate = true;
            }
          }

          // checking for duplicate name
          name = name?name.trim():''
          if (name != '' && name?.toLowerCase() == instance.name?.trim()?.toLowerCase() && project.refContentId!='Xy2NqqO8nPYI7YQFfETfr93GlkG3') {
            if(personalSettings.length == 1 && personalSettings[0] == 'name'){
              responseDoc.name = true;
              if (projectSetting.regName) {
                responseDoc.isDuplicate = true;
              }
            }
          }

          // checking for duplicate phone
          if (phone != '' && phone == instance.phone) {
            responseDoc.phone = true;
            if (projectSetting.regPhoneNumber) {
              responseDoc.isDuplicate = true;
            }
          }
          // checking for duplicate seatnumber
          seatNumber = seatNumber?seatNumber.trim():''
          if (seatNumber != '' && seatNumber?.toLowerCase() == instance.seatNumber?.toLowerCase()) {
            responseDoc.seatNumber = true;
            if (projectSetting.regSeatNumber) {
              responseDoc.isDuplicate = true;
            }
          }
        })

        resolve(responseDoc)
      }).catch((err)=>{
        reject(err)
      })

    })
  }

  // player registration : here we are checking player valid or not for approvedPlayer ( email )
  checkApprovedPlayerValidOrNot(quizId: any, email: any,contestId:any = null) {
    return new Promise((resolve, reject) => {
      let quizInvitationData: any;
      let quizInvitationRef: any;
      if(contestId){
        quizInvitationRef = query(collection(this.firestore, 'quizInvitation'), where("contestId", "==", contestId), where("email", "==", email), where("isDeleted", "==", false), orderBy("createdOn", "asc"), limit(1))
      }else{
        quizInvitationRef = query(collection(this.firestore, 'quizInvitation'), where("quizId", "==", quizId), where("email", "==", email), where("isDeleted", "==", false), orderBy("createdOn", "asc"), limit(1))
      }
      getDocs(quizInvitationRef).then((docs) => {
        docs.forEach((doc) => {
          quizInvitationData = doc.data()
          // console.log(quizInvitationData)
          if (quizInvitationData) {
            this.checkInvitation(quizInvitationData.inviteId).then((res: any) => {
              if (res) {
                resolve(res);
              }
            })
          } else {
            resolve(quizInvitationData);
          }
        });
        resolve(quizInvitationData);
      }).catch((err)=>{
        reject(err)
      })
    })
  }
  // player registration : here we are checking player valid or not for username password 
  checkUsernamePassswordValidOrNot(quizId: any, username: any, password: any,contestId:any = null) {
    return new Promise((resolve, reject) => {
      let quizInvitationData: any;
      let quizInvitationRef: any;
      if(contestId){
        quizInvitationRef = query(collection(this.firestore, 'quizInvitation'), where("contestId", "==", quizId), where("username", "==", username), where("password", "==", password), where("isDeleted", "==", false), orderBy("createdOn", "asc"), limit(1))
      }else{
        quizInvitationRef = query(collection(this.firestore, 'quizInvitation'), where("quizId", "==", quizId), where("username", "==", username), where("password", "==", password), where("isDeleted", "==", false), orderBy("createdOn", "asc"), limit(1))
      }
      getDocs(quizInvitationRef).then((docs) => {
        docs.forEach((doc) => {
          quizInvitationData = doc.data()
          // console.log(quizInvitationData)
          if (quizInvitationData && !quizInvitationData.isDeleted) {
            this.checkInvitation(quizInvitationData.inviteId).then((res: any) => {
              if (res) {
                resolve(res);
              }
            })
          } else {
            resolve(quizInvitationData);
          }
        });
        resolve(quizInvitationData);
      }).catch((err)=>{
        reject(err)
      })
    })
  }

  async checkInvitation(id: any, userName: any = null) {
    return new Promise(async (resolve, reject) => {
      let inviteDetails: any;
      let quizRef = doc(this.firestore, 'quizInvitation', id)
      await getDoc(quizRef).then((doc) => {
        inviteDetails = doc.data();
        if (inviteDetails && userName) {
          if (inviteDetails.username?.toLowerCase() == userName) {
            resolve(inviteDetails)
          } else {
            resolve(false)
          }
        } else {
          resolve(inviteDetails)
        }
      })
    }).catch((err) => {
      console.log("err==>", err)
    })
  }
  async registerInviteUser(id: any, details: any) {
    try {
      return await new Promise(async (resolve, reject) => {
        let projectRef = doc(this.firestore, 'quizInvitation', id);
        setDoc(projectRef, details, { merge: true }).then((result) => {
          resolve(result);

        });
      });
    } catch (err) {
      console.log("err==>", err);
      return err;
    }

  }
  updateQuizInviteDoc(inviteId: any, inviteDetails: any) {
    try {
      return new Promise(async (resolve: any, reject: any) => {
        let docRef = doc(this.firestore, 'quizInvitation', inviteId);
        updateDoc(docRef, inviteDetails).then((res: any) => {
          resolve(true)
        }).catch((updateDocErr: any) => {
          console.log('Error found while updating inviteDetails in given id : ', inviteId, ' : ', updateDocErr)
          reject(false)
        })
      })
    } catch (error: any) {
      console.log("Error found in updateQuizInviteDoc method : ", error)
      return error;
    }
  }
  getRegisterInviteDetailsByUsername(username: any) {
    return new Promise(async (resolve: any, reject: any) => {
    try {
        let inviteDetails: any;
        let quizInviteRef = collection(this.firestore, 'quizInvitation')
        let quizInviteQueryRef = query(quizInviteRef, where('username', '==', username))
        await getDocs(quizInviteQueryRef).then((docs) => {
          docs.forEach((doc: any) => {
            if (doc.data()) {
              inviteDetails = doc.data();
            }
          });
        })
        resolve(inviteDetails)
   
    } catch (error: any) {
      console.log("error in getRegisterInviteDetailsByUsername : ", error)
      reject(error) ;
    }
  })
  }
  public getTemplates(showTemplates: number) {
    return new Promise(async (resolve, reject) => {
      let templateRef = collection(this.firestore, 'template')
      let templateQueryRef = query(templateRef, orderBy("creationDate", "desc"), limit(showTemplates));
      let querySnapshot = await getDocs(templateQueryRef)
      let templatesList: any = []
      querySnapshot.forEach((doc) => {
        templatesList.push(doc.data());
      });
      if (templatesList && templatesList.length) {
        let templatesPromise: any = []
        for (let idx = 0; idx < templatesList.length; idx++) {
          templatesPromise.push(this.templateDataPromise(templatesList[idx]))
        }
        Promise.all(templatesPromise).then((result) => {
          resolve(result)
        }).catch((err) => {
          // console.log(err)
          resolve([])
        })
      } else {
        resolve([])
      }
    })
  }

  private templateDataPromise(template: any) {
    return new Promise((resolve, reject) => {
      let queryRef = doc(this.firestore, 'contentAccountMapping', template.refContentId, 'quiz', template.templateId)
      getDoc(queryRef).then((doc) => {
        let quizDetails: any;
        quizDetails = doc.data();
        quizDetails.quizId = doc.id;
        quizDetails.refContentId = template.refContentId;
        resolve(quizDetails)
      }).catch(err => {
        reject(err)
      })
    })
  }

  public getQuizsByQuizIdContentIdList(contentQuizList: any[]) {
    return new Promise((resolve, reject) => {
      let accessPromise: any = []
      for (let idx = 0; idx < contentQuizList.length; idx++) {
        let quiz = contentQuizList[idx];
        // if list have quizId only then push it
        if (quiz.quizId)
          accessPromise.push(this.getQuizDetailsById(quiz.quizId, quiz.contentId))
      }
      Promise.all(accessPromise).then((result) => {
        resolve(result)
      }).catch((err) => {
        // console.log(err)
        resolve([])
      })
    })
  }

  public getProjectsForHome(page: any = null, paginatingForward: any = null, quizs: any = null) {
    return new Promise(async (resolve, reject) => {
      try {
        const quizRef = query(collectionGroup(this.firestore, 'quiz'), where('refAccountId', '==', 'ebGl6wWxjERc6cHt0fDQ'), where('quizStatus', 'in', ['p']), where('isPublic', '==', true));
        const querySnapshot = await getDocs(quizRef);
        let quizs: any = []
        querySnapshot.forEach((doc) => {
          let quizDetails: any;
          // console.log(doc.id, ' => ', doc.data());
          quizDetails = doc.data();
          quizDetails.quizId = doc.id;
          quizs.push(quizDetails)
        });
        resolve(quizs)
      } catch (error) {
        reject(error)
      }
      // let contentRef = collection(this.firestore, 'contentAccountMapping')
      // let ref = null;
      /*
      Older quiz collection
      if (page == 1) {
        ref = query(quizRef, where('isPublic', '==', true), where('status', '==', "Published"), orderBy('createdOn', 'desc'), limit(24));
      }
      else {
        if (paginatingForward) {
          var lastDoc = quizs[quizs.length - 1];
          ref = query(quizRef, where('isPublic', '==', true), where('status', '==', "Published"), orderBy('createdOn', 'desc'),startAfter(lastDoc['createdOn']), limit(24));

        }
        else {
          var firstDoc = quizs[0];
          ref = query(quizRef, where('isPublic', '==', true), where('status', '==', "Published"), orderBy('createdOn', 'desc'),endBefore(firstDoc.createdOn), limitToLast(24));
        }
      }
      getDocs(ref).then((docs) => {
        resolve(docs)
      }).catch((err) => {
        reject(err)
      })
      */
      // let accountquery = query(contentRef, where('refAccountId', '==', 'ebGl6wWxjERc6cHt0fDQ'))
      // let contentIds:any = []
      // await getDocs(accountquery).then((docs) => {
      //   docs.forEach(doc => {
      //     contentIds.push(doc.id)
      //   })
      // })
      // let quizsPromise = []
      // for (let idx = 0; idx < contentIds.length; idx++) {
      //   let contentId = contentIds[idx];
      //   quizsPromise.push(this.getPublicQuizsBycontentId(contentId))
      // }
      // Promise.all(quizsPromise).then((result) => {
      //   let quizList:any = [];
      //   result.forEach((quizs:any) =>{
      //     if (quizs && quizs.length){
      //       quizList = quizList.concat(quizs)
      //     }
      //   })
      //   resolve(quizList)
      // }).catch((err) => {
      //   console.log(err)
      //   resolve([])
      // })
    })
  }

  // getPublicQuizsBycontentId(contentId:string) {
  //   return new Promise((resolve, reject) => {
  //     let queryRef = query(collection(this.firestore,'contentAccountMapping', contentId, 'quiz'), where('isPublic', '==', true))
  //     getDocs(queryRef).then((docs) => {
  //       let quizs:any = []
  //       docs.forEach((doc) => {
  //         let quizDetails:any;
  //         quizDetails = doc.data();
  //         quizDetails.quizId = doc.id;
  //         quizDetails.refContentId = contentId
  //         quizs.push(quizDetails)
  //       });
  //       resolve(quizs)
  //     }).catch(err => {
  //       reject(err)
  //     })
  //   })
  // }


  public updateProject(projectId: string, projectDetails: any, approved: any = null) {
    return new Promise((resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      const updatedOn = serverTimestamp();
      const updatedBy = getAuth().currentUser?.uid;

      projectDetails.updatedOn = updatedOn;
      if (updatedBy && approved === null) {
        projectDetails.updatedBy = updatedBy;
        if (projectDetails['quizStatus'] == 'p')
          projectDetails['publishedOn'] = serverTimestamp()
      }
      
      let docRef = doc(this.firestore, 'contentAccountMapping', userContentRef.contentId, "quiz", projectId);
      updateDoc(docRef, projectDetails).then(() => {
        resolve(projectDetails)
      }).catch((err)=>{
        reject(err)
      })
    })
  }

  public getProjectDetailsByIdPromise(quizId: string) {
    return new Promise(async (resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      let docRef = doc(this.firestore, 'contentAccountMapping', userContentRef.contentId, "quiz", quizId);
      await getDoc(docRef).then((doc) => {
        let quizDetails: any;
        quizDetails = doc.data();
        quizDetails.quizId = doc.id;
        quizDetails.refContentId = userContentRef.contentId;
        resolve(quizDetails)
      }).catch(err => {
        reject(err)
      })
    })
  }

  getQuizByQuizName(contentId:any,quizName:any){
    return new Promise(async (resolve, reject) => {
      try {
        const quizRef = query(collectionGroup(this.firestore, 'quiz'), where('refContentId', '==', contentId), where('quizName', '==', quizName),where('quizStatus', 'in', ['p']));
        const querySnapshot = await getDocs(quizRef);
        let quizs: any = []
        if(querySnapshot.size != 0){
          querySnapshot.forEach((doc) => {
            let quizDetails: any;
            quizDetails = doc.data();
            quizDetails.quizId = doc.id;
            quizs.push(quizDetails)
          });
          resolve(quizs)
        }else{
          resolve(quizs)
        }
      } catch (error) {
        reject(error)
      }
    })
  }

  public getProjectByContentId(contentId: any) {  //====getting all quizzes of that content id 
    return new Promise(async (resolve, reject) => {
      let quizs: any = []
      let docRef = collection(this.firestore, 'contentAccountMapping', contentId, 'quiz');
      await getDocs(docRef).then((snapshot) => {
        snapshot.forEach((doc: any) => {
          var q = doc.data();
          q['quizId'] = doc.id;
          q['refContentId'] = contentId
          quizs.push(q);
        });
        resolve(quizs)
      }).catch(err => {
        reject(err)
      })
    })
  }


  // getProjectList(createdBy:string, quizStatus:string, quizs:any) {
  //   return new Promise(async (resolve, reject) => {
  //     var quizRef:any
  //     let userContentRef = this.userService.getUserContentRef()
  //     if (!userContentRef) {
  //       reject(null)
  //       return
  //     }
  //     quizRef = collection(this.firestore, 'contentAccountMapping', userContentRef.contentId, 'quiz')
  //     let queryRef:any;
  //     if(quizs.length == 0){
  //       if(quizStatus=="All"){
  //         queryRef = query(quizRef,where('createdBy', '==', createdBy),where('quizStatus','in',['d','p']),orderBy('creationDate','desc'),limit(10));        }
  //       else if(quizStatus == 'u'){
  //         let quizStatus = 'p'
  //         queryRef = query(quizRef,where('createdBy', '==', createdBy),where('quizStatus', '==', quizStatus),orderBy('creationDate','desc'),limit(10));
  //       }else{
  //         queryRef = query(quizRef,where('createdBy', '==', createdBy), where('quizStatus', '==', quizStatus),orderBy('creationDate','desc'), limit(10));
  //       }
  //     }
  //     else{
  //       if(quizStatus=="All"){
  //         var lastDoc = quizs[quizs.length-1];
  //         queryRef = query(quizRef, where('createdBy', '==', createdBy),where('quizStatus','in',['d','p']),orderBy('creationDate','desc'), startAfter(lastDoc['creationDate']),limit(10));
  //       }else if(quizStatus == 'u'){
  //         let quizStatus = 'p'
  //         var lastDoc = quizs[quizs.length-1];
  //         queryRef = query(quizRef, where('createdBy', '==', createdBy),where('quizStatus', '==', quizStatus),orderBy('creationDate','desc'), startAfter(lastDoc['creationDate']),limit(10));
  //       }
  //       else{
  //         if(status=='f'){
  //           // console.log(status)
  //         }else{
  //           var lastDoc = quizs[quizs.length-1];
  //           queryRef = query(quizRef, where('createdBy', '==', createdBy),where('quizStatus', '==', quizStatus),orderBy('creationDate','desc'), startAfter(lastDoc['creationDate']), limit(10));
  //         }
  //       }
  //     }
  //     getDocs(queryRef).then((docs) => {
  //       resolve(docs)
  //     }).catch((err) => {
  //       reject(err)
  //     })
  //   })
  // }

  getProjectList(accountId: string, quizStatus: string, quizs: any, specificAC: any = null) {
    return new Promise(async (resolve, reject) => {
      let whereQuery: QueryConstraint[] = [
        orderBy('creationDate', 'desc')
      ]
      // get the users query and current query
      if (!specificAC)
        whereQuery = await this.userSettings.getQuery(whereQuery)
      else
        whereQuery.push(where('refAccountId', '==', accountId))

      // let userContentAccount = this.userService.getUserContentAccount()
      // if (!userContentAccount || userContentAccount.refAccountId != accountId) {
      //   reject(null)
      //   return
      // }
      let queryRef: any;
      if (quizs.length == 0) {
        if (quizStatus == "All") {
          whereQuery.push(where('quizStatus', 'in', ['d', 'p']))
        }
        else if (quizStatus == 'u') {
          let quizStatus = 'p'
          whereQuery.push(where('quizStatus', '==', quizStatus));
        } else {
          whereQuery.push(where('quizStatus', '==', quizStatus));
        }
      }
      else {
        if (quizStatus == "All") {
          var lastDoc = quizs[quizs.length - 1];
          whereQuery.push(where('quizStatus', 'in', ['d', 'p']))
          whereQuery.push(startAfter(lastDoc['creationDate']))
        } else if (quizStatus == 'u') {
          let quizStatus = 'p'
          var lastDoc = quizs[quizs.length - 1];
          whereQuery.push(where('quizStatus', '==', quizStatus))
          whereQuery.push(startAfter(lastDoc['creationDate']))
        }
        else {
          if (status == 'f') {
            // console.log(status)
          } else {
            var lastDoc = quizs[quizs.length - 1];
            whereQuery.push(where('quizStatus', '==', quizStatus))
            whereQuery.push(startAfter(lastDoc['creationDate']))

          }
        }
      }
      whereQuery.push(limit(10))
      queryRef = query(collectionGroup(this.firestore, 'quiz'), ...whereQuery);
      getDocs(queryRef).then((docs) => {
        resolve(docs)
      }).catch((err) => {
        reject(err)
      })
    })
  }


  //published and distributed 
  _publishedAndDistributed(quiz: any) {
    return new Promise((resolve, reject) => {
      let instancesId = collection(this.firestore, 'instances')
      let instancesDetails = query(instancesId, where('quiz', '==', quiz.quizId), orderBy('createdOn', 'desc'), limit(1))  //get inst
      getDocs(instancesDetails).then((docs) => {
        if (docs.size) {
          resolve(quiz)
          // docs.forEach(_doc => {
          //   if(_doc.data().id){   //checking id available or not
          //     let instanceQuizId:any = _doc.data().quiz //instances quizId
          //     if(instanceQuizId == quiz.quizId)  //checking quizId
          //       resolve(quiz) //quiz details
          //   }
          // });
        } else {
          resolve(null)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }

  //published but not distributed
  public publishedButNotDistributed(quiz: any) {
    return new Promise((resolve, reject) => {
      let instancesId = collection(this.firestore, 'instances')
      let instancesDetails = query(instancesId, where('quiz', '==', quiz.quizId), orderBy('createdOn', 'desc'), limit(1))  //get inst
      getDocs(instancesDetails).then((docs) => {
        if (docs.size) {
          resolve(quiz)
          // docs.forEach(_doc => {
          //   if(_doc.data().id){   //checking id available or not
          //     let instanceQuizId:any = _doc.data().quiz //instances quizId
          //     if(instanceQuizId == quiz.quizId)  //checking quizId
          //       resolve(quiz) //quiz details
          //   }
          // });
        } else {
          resolve(null)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }

  getOtherQuizList(createdBy: string, quizStatus: string, quizs: any) {
    return new Promise((resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      let quizRef = collection(this.firestore, 'contentAccountMapping', userContentRef.contentId, 'quiz')
      let queryRef: any;
      if (quizs.length == 0) {
        queryRef = query(quizRef, where('createdBy', '==', createdBy), where('quizStatus', '==', quizStatus), orderBy('creationDate', 'desc'), limit(3));
      }
      else {
        var lastDoc = quizs[quizs.length - 1];
        queryRef = query(quizRef, where('createdBy', '==', createdBy), where('quizStatus', '==', quizStatus), orderBy('creationDate', 'desc'), startAfter(lastDoc['creationDate']), limit(3));
      }
      getDocs(queryRef).then((docs) => {
        resolve(docs)
      }).catch((err) => {
        reject(err)
      })
    })
  }

  // universal function to create quiz from anywhere
  createProject(projectDetails: any) {
    // show Rules disable only for pvr template
    if(projectDetails && (projectDetails.refTemplateId == '49020fd8-e549-47e6-acc5-683f6794ad91' ||  projectDetails.refTemplateId == 'aa16fa0d-4b81-4f17-9cda-d523a687b9f3'))
      projectDetails['showRules'] = false
    return new Promise((resolve, reject) => {
      if (projectDetails && projectDetails.quizId) {

        let userContentRef = this.userService.getUserContentRef();
        if (projectDetails.contentId) {
          userContentRef = {}
          userContentRef['contentId'] = projectDetails.contentId
        }
        if (projectDetails.createdBy === 'Quiz') {
          projectDetails.createdBy = userContentRef.contentId;
          projectDetails.refContentId = userContentRef.contentId;
          projectDetails.refAccountId = userContentRef.contentId
          projectDetails.contentId = userContentRef.contentId
        }
        let projectRef = doc(this.firestore, 'contentAccountMapping', userContentRef.contentId, 'quiz', projectDetails.quizId);
        setDoc(projectRef, projectDetails).then((result) => {   
          resolve(projectDetails);
        }).catch((err) => {
          reject(err);
        });
      } else {
        reject(null)
      }
    })
  }

  async createQuizFormTemplate(projectId: string) {
    return new Promise((resolve, reject) => {
      let templateRef = doc(collection(this.firestore, 'template'), projectId)
      getDoc(templateRef).then((doc) => {
        let templateDetails: any = doc.data();
        if (templateDetails?.refContentId) {
          this.getQuizDetailsById(projectId, templateDetails.refContentId).then((projectDetails: any) => {
            if (projectDetails) {
              let userContentRef = this.userService.getUserContentRef()
              let userInfo = this.userService.getUser();
              delete projectDetails['refContentId'];
              delete projectDetails['refAccountId'];
              delete projectDetails['lastUpdateDate'];
              delete projectDetails['updatedBy'];
              projectDetails['creatorName'] = getAuth().currentUser?.displayName || userInfo.userData?.name ? userInfo.userData.name : "";
              projectDetails['hasOwnsettings'] = false;
              projectDetails['isTemplate'] = false;
              projectDetails['isPublic'] = false;
              projectDetails['refTemplateId'] = projectDetails['quizId'];
              projectDetails['quizName'] = 'Enter title of the quiz*';
              projectDetails['quizDescription'] = '';
              projectDetails['quizStatus'] = "d";
              projectDetails['createdBy'] = getAuth().currentUser?.uid;
              projectDetails['creationDate'] = serverTimestamp();
              projectDetails['quizId'] = this.helperService.uuidv4();
              projectDetails['refAccountId'] = userContentRef.refAccountId;
              projectDetails['refContentId'] = userContentRef.contentId;
              projectDetails['logoImagePosition'] = 'bottomLeft'
              this.createProject(projectDetails).then((newProject: any) => {
                newProject.preRefContentId = templateDetails.refContentId;
                resolve(newProject)
              }).catch(err => {
                reject(null)
              })
            } else {
              reject(null)
            }
          });
        } else {
          reject(null)
        }
      }).catch((err) => {
        reject(null)
      })
    })
  }

  createfromTemplate(templateId: any) {
    return new Promise(async (resolve, reject) => {
      let templateRef = doc(collection(this.firestore, 'template'), templateId)
      //get settings of template
      let settings = await this.projectSetting.getProjectSettingsById(templateId)
      getDoc(templateRef).then((doc) => {
        let templateDetails: any = doc.data();
        if (templateDetails && templateDetails['templateId']) {
          let projectDetails: any = {}
          let userContentRef = this.userService.getUserContentRef()
          let userInfo = this.userService.getUser();
          projectDetails['quizId'] = this.helperService.uuidv4();
          projectDetails['quizName'] = 'Enter title of the quiz*';
          projectDetails['quizDescription'] = '';
          projectDetails['quizType'] = templateDetails['quizType'] ? templateDetails['quizType'] : 's'
          projectDetails['quizStatus'] = "d";
          projectDetails['refTemplateId'] = templateDetails['templateId'];
          projectDetails['rules'] = ''
          projectDetails['hasOwnsettings'] = false;
          projectDetails['startedDate'] = ''
          projectDetails['endDate'] = ''
          projectDetails['isPublic'] = false;
          projectDetails['coverImageAltText'] = ''
          projectDetails['coverImageSource'] = ''
          projectDetails['coverImageObjectFit'] = 'cover'
          projectDetails['coverImageUrl'] = templateDetails['coverImageUrl'] ?? ""
          projectDetails['coverImageResizedImageUrl'] = ''
          projectDetails['logoImageAltText'] = ''
          projectDetails['logoImageSource'] = ''
          projectDetails['logoImageResizedImageUrl'] = ''
          projectDetails['logoImageUrl'] = ''
          projectDetails['creatorName'] = getAuth().currentUser?.displayName || userInfo.userData?.name ? userInfo.userData.name : "";
          projectDetails['creatorImageAltText'] = ''
          projectDetails['creatorImageResizedImageUrl'] = ''
          projectDetails['creatorImageSource'] = ''
          projectDetails['creatorImageUrl'] = ''
          projectDetails['creationDate'] = serverTimestamp();
          projectDetails['isTemplate'] = false;
          projectDetails['createdBy'] = getAuth().currentUser?.uid;
          projectDetails['refAccountId'] = userContentRef.refAccountId;
          projectDetails['refContentId'] = userContentRef.contentId;
          projectDetails['topic'] = ''
          projectDetails['logoImagePosition'] = 'bottomLeft'
          if(templateId=='49020fd8-e549-47e6-acc5-683f6794ad91' || templateId == 'aa16fa0d-4b81-4f17-9cda-d523a687b9f3'){
            projectDetails['accessClosureMinute'] = templateDetails['accessClosureMinute'];
            projectDetails['isMinPlayerRequired'] = templateDetails['isMinPlayerRequired'];
            projectDetails['minPlayerLimit'] = templateDetails['minPlayerLimit'];
            projectDetails['voiceOver'] = templateDetails['voiceOver']?templateDetails['voiceOver']:'';
          }
          //if template settings has certificate true then add default field to project
          if (settings && settings.hasCert) {
            projectDetails['certId'] = 'default'
            projectDetails['openDateTime'] = new Date()
            projectDetails['closeDateTime'] = new Date(new Date().setDate(new Date().getDate() + 30));
          } else {
            projectDetails['certId'] = ''
            projectDetails['openDateTime'] = ""
            projectDetails['closeDateTime'] = ""
          }
          this.createProject(projectDetails).then((newProject: any) => {
            newProject.preRefContentId = templateDetails['refContentId'];
            resolve(newProject)
          }).catch(err => {
            reject(null)
          })

        } else {
          reject(null)
        }
      }).catch((err) => {
        reject(null)
      })
    })
  }

  //create new setting (quiz operation)
  createSetting(projectSettings: any) {
    return new Promise((resolve, reject) => {
      let settingRef = doc(this.firestore, 'setting', projectSettings.settingId)
      setDoc(settingRef, projectSettings).then((result) => {
        resolve(projectSettings)
      }).catch(err => {
        reject(err)
      })
    })
  }
  //create new questions (quiz operation)
  createQuestion(question: any) {
    let userContentRef = this.userService.getUserContentRef()
    return new Promise((resolve, reject) => {
      let questionRef = doc(this.firestore, 'contentAccountMapping', userContentRef.contentId, 'quiz', question.refQuizId, 'question', question.questionId)
      setDoc(questionRef, question).then((result) => {
        resolve(question)
      }).catch(err => {
        reject(err)
      })
    })
  }
  //update questions (quiz operation)
  public updateQuestion(quizId: any, questionDetails: any, contentId: any = null) {
    return new Promise((resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      if (!contentId)
        contentId = userContentRef.contentId
      const updatedOn = serverTimestamp();
      questionDetails.updatedOn = updatedOn;
      let docRef = doc(this.firestore, 'contentAccountMapping', contentId, 'quiz', quizId, 'question', questionDetails.questionId)
      updateDoc(docRef, questionDetails)
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //quiz copy operations
  quizCopyOperation(projectDetails: any, projectSettingDetails: any, projectQuestionsDetails: any) {
    return new Promise((resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef();
      if (projectDetails != null) {
        //set projectDetails
        delete projectDetails['sharedOn']
        projectDetails["quizName"] = projectDetails["quizName"] + ' ' + '(1)';
        projectDetails['quizId'] = this.helperService.uuidv4();
        projectDetails['quizStatus'] = 'd';
        projectDetails['isPublic'] = false;
        projectDetails['openDateTime'] = '';
        projectDetails['closeDateTime'] = '';
        projectDetails['creationDate'] = serverTimestamp();
        projectDetails['createdBy'] = userContentRef['createdBy'];
        projectDetails['refAccountId'] = userContentRef['refAccountId'];
        projectDetails['refContentId'] = userContentRef['contentId'];
        this.createProject(projectDetails)
        // create quiz owner first access (quiz id and user details store)
        this.accessesService.createQuizOwnerFirstAccess(projectDetails)
        //set projectSettingDetails
        if (projectSettingDetails != null) {
          projectSettingDetails['settingId'] = projectDetails['quizId']
          projectSettingDetails['creationDate'] = serverTimestamp();
          projectSettingDetails['createdBy'] = userContentRef['createdBy'];
          projectSettingDetails['approvedPlayer'] = false
          if (projectSettingDetails['uploadPlayerUsernamePassword']) {
            projectSettingDetails['uploadPlayerUsernamePassword'] = false
            projectSettingDetails['requiresSignIn'] = false
          }
          if(projectSettingDetails.nonLivePin){
            projectSettingDetails.nonLivePin = ''
          }
          if (projectSettingDetails.hasCert) {
            projectSettingDetails.hasCert = false
            projectSettingDetails.downloadCert = false
          }
          if (projectSettingDetails.enableDrs) {
            projectSettingDetails.enableDrs = false;
            projectSettingDetails.playerLed = false;
            projectSettingDetails.enableDrsDateTime = false;
            projectSettingDetails.creatorModerated = false;
            projectSettingDetails.drsStartDateTime = "";
            projectSettingDetails.drsEndDateTime = "";
          }
          this.createSetting(projectSettingDetails)
        }
        //set projectQuestionsDetails
        if (projectQuestionsDetails != null) {
          projectQuestionsDetails.forEach((question: any) => {
            question['refQuizId'] = projectDetails['quizId']
            question['questionId'] = this.helperService.uuidv4();
            question['creationDate'] = serverTimestamp();
            question['createdBy'] = userContentRef['createdBy'];
            question['refAccountId'] = userContentRef['refAccountId'];
            question['refContentId'] = userContentRef['contentId'];
            this.createQuestion(question)
          });
          let newQuizId = projectDetails['quizId']
          resolve(newQuizId)
        }
      }
    })
  }
  //quiz delete operations
  quizDeleteOperation(projectDetails: any, projectQuestionsDetails: any= null) {
    return new Promise((resolve, reject) => {
      if (projectDetails != null) {
        //update projectDetails
        projectDetails["quizStatus"] = "t";
        this.updateProject(projectDetails.quizId, projectDetails).then((result: any) => {
          //update projectQuestionsDetails
          if (projectQuestionsDetails != null) {
            projectQuestionsDetails.forEach((question: any) => {
              question['questionStatus'] = 't'
              this.updateQuestion(projectDetails['quizId'], question)
            })
            resolve(result)
          }
        }).catch((err)=>{
          reject(err)
        })
      }
    })
  }
  // get Most Viewed Quizs
  public getQuizStatsList(quizStats: any) {
    return new Promise(async (resolve, reject) => {
      try {
        const quizStatsRef = collection(this.firestore, 'quiz_stats')
        let quizStatsQueryRef: any;
        if (quizStats.length == 0) {
          quizStatsQueryRef = query(quizStatsRef, orderBy('viewedCount', 'desc'), limit(15))
        }
        else {
          var lastDoc = quizStats[quizStats.length - 1];
          quizStatsQueryRef = query(quizStatsRef, orderBy('viewedCount', 'desc'), startAfter(lastDoc['viewedCount']), limit(10))
        }

        const querySnapshot = await getDocs(quizStatsQueryRef);
        let quizId: any = []
        querySnapshot.forEach((doc) => {
          let quizDetails: any;
          // console.log(doc.id, ' => ', doc.data());
          quizDetails = doc.data();
          quizDetails.id = doc.id
          quizId.push(quizDetails)
        });
        resolve(quizId)
      } catch (error) {
        reject(error)
      }
    });
  }
  // getQUiz for trending
  public getQuizbyListofQuizId(listofQuizId: any) {
    return new Promise(async (resolve, reject) => {
      try {
        let quizPromise = []
        let quizs: any = []
        for (let idx = 0; idx < listofQuizId.length; idx++) {
          quizPromise.push(this.getQuizByCollectionGroup(listofQuizId[idx]))
        }
        Promise.all(quizPromise).then(async (quizsList: any) => {
          for (let i = 0; i < quizsList.length; i++) {
            if (quizsList[i]) {
              // let hasAccess =  await this.accessControl.isAccessGiven(quizsList[i])
              // if(hasAccess)
              quizs.push(quizsList[i])
            }
          }
          resolve(quizs)
        }).catch((err) => {
          // console.log('err : ', err)
          resolve([])
        })
      } catch (error) {
        console.log(error)
      }
    })
  }

  // get shared on spring quizzzes for tranding page
  public getQuizByCollectionGroupForTrandingPage() {
    return new Promise(async (resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef();
      const quizRef = query(collectionGroup(this.firestore, 'quiz'), where("quizStatus", '==', 'p'), where("refAccountId", '==', userContentRef['refAccountId']), orderBy('sharedOnSpring', 'desc'));
      const querySnapshot = await getDocs(quizRef);
      let quizDetails: any = [];
      querySnapshot.forEach((doc) => {
        let qD:any = doc.data();
        qD.quizId = doc.id;
        quizDetails.push(qD)
      });
      if (quizDetails) {
        resolve(quizDetails)
      }
      else {
        resolve(null)
      }
    })
  }

  public getQuizByCollectionGroup(quizId: any) {
    return new Promise(async (resolve, reject) => {
      const quizRef = query(collectionGroup(this.firestore, 'quiz'), where("quizId", "==", quizId));
      const querySnapshot = await getDocs(quizRef);
      let quizDetails: any;
      querySnapshot.forEach((doc) => {
        let _quizDetails:any = doc.data();
        if (_quizDetails.quizStatus != 't') {
          quizDetails = _quizDetails
          // if(quizDetails.quizStats == 'd' && quizDetails.quizStats == 'p'){//doubt for this line
          quizDetails.quizId = doc.id;
          // }
        }
      });
      if (quizDetails) {
        resolve(quizDetails)
      }
      else {
        resolve(null)
      }
    })
  }

  public getQuizBycategoryIdCollectionGroup(categoryId: any, accountId: any, quizs: any, quizlimit: any) {
    return new Promise(async (resolve, reject) => {
      let whereQuery: QueryConstraint[] = [

        where('refAccountId', '==', accountId),
        where('quizStatus', 'in', ['p']),
        orderBy('sharedOn', 'desc')
      ]
      if (categoryId) {
        whereQuery.push(where("refCategoryId", "==", categoryId))
      }
      let queryRef: any;
      if (quizs.length != 0) {
        var lastDoc = quizs[quizs.length - 1];
        whereQuery.push(startAfter(lastDoc['sharedOn']))

      }
      whereQuery.push(limit(quizlimit))
      queryRef = query(collectionGroup(this.firestore, 'quiz'), ...whereQuery);
      const querySnapshot = await getDocs(queryRef);
      let quizDetails: any = [];
      querySnapshot.forEach((doc) => {
        quizDetails.push(doc.data())
      });
      if (quizDetails && quizDetails.length) {
        resolve(quizDetails)
      }
      else {
        resolve(null)
      }
    })

    // return new Promise(async (resolve, reject) => {
    //   const quizRef = query(collectionGroup(this.firestore, 'quiz'),where("refCategoryId","==",categoryId),where('refAccountId','==',accountId),where('quizStatus','in',['p']), orderBy('creationDate','desc'),limit(quizlimit));
    //   const querySnapshot = await getDocs(quizRef);
    //   let quizDetails: any=[];
    //   querySnapshot.forEach((doc) => {
    //     quizDetails.push(doc.data())
    //   });
    //   if (quizDetails && quizDetails.length) {
    //     resolve(quizDetails)
    //   }
    //   else {
    //     resolve(null)
    //   }
    // })
  }

  public getNewTemplates(showTemplates: number, template: any) {
    return new Promise(async (resolve, reject) => {
      try {
        let templateRef = collection(this.firestore, 'template')
        let templateQueryRef: any;
        if (template == 'Quiz formats')
          templateQueryRef = query(templateRef, where('templateStatus', '==', ''), orderBy('creationDate', 'desc'));//, limit(showTemplates)
        else if (template == 'useCase')
          templateQueryRef = query(templateRef, where('useCase', '!=', ''), where('templateStatus', '==', ''), orderBy('useCase'), orderBy('creationDate', 'desc'));//, limit(showTemplates)
        else if (template == 'bzFunction')
          templateQueryRef = query(templateRef, where('bzFunction', '!=', ''), where('templateStatus', '==', ''), orderBy('bzFunction'), orderBy('creationDate', 'desc'));//, limit(showTemplates)
        else
          templateQueryRef = query(templateRef, where('templateTheme', '!=', ''), where('templateStatus', '==', ''), orderBy('templateTheme'), orderBy('creationDate', 'desc'));//, limit(showTemplates)

        let querySnapshot = await getDocs(templateQueryRef)
        let templatesList: any = []
        querySnapshot.forEach((doc) => {
          templatesList.push(doc.data());
        });
        resolve(templatesList)
        // if (templatesList && templatesList.length) {
        //   let templatesPromise:any = []
        //   for(let idx = 0; idx < templatesList.length; idx++) {
        //     templatesPromise.push(this.templateDataPromise(templatesList[idx]))
        //   }
        //   Promise.all(templatesPromise).then((result) => {
        //     resolve(result)
        //   }).catch((err) => {
        //     console.log(err)
        //     resolve([])
        //   })
        // } else {
        //   resolve([])
        // }
      } catch (err) {
        reject(err)
      }
    })
  }

  public getQuizsbyTemplateId(templateId: any = null, totalQuizs: any) {
    return new Promise(async (resolve, reject) => {
      try {
        let quizs: any = []
        let quizRef: any
        if (totalQuizs.length == 0) {
          quizRef = query(collectionGroup(this.firestore, 'quiz'), where("refTemplateId", "==", templateId), where('isPublic', '==', true), where('quizStatus', 'in', ['p']), orderBy('creationDate', 'desc'), limit(13));
        }
        else {
          var lastDoc = totalQuizs[totalQuizs.length - 1];
          quizRef = query(collectionGroup(this.firestore, 'quiz'), where("refTemplateId", "==", templateId), where('isPublic', '==', true), where('quizStatus', 'in', ['p']), orderBy('creationDate', 'desc'), startAfter(lastDoc['creationDate']), limit(13));
        }
        const querySnapshot = await getDocs(quizRef);
        querySnapshot.forEach((doc) => {
          let quizDetails: any;
          // console.log(doc.id, ' => ', doc.data());
          quizDetails = doc.data();
          quizDetails.quizId = doc.id;
          quizs.push(quizDetails)
        });
        resolve(quizs)
      } catch (error) {
        reject(error)
      }
    })
  }
  //--------------------start favorite quiz-------------------------------
  //add favorite quizs
  onAddFavoriteQuiz(quizId: any) {
    return new Promise((resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      // let quizRef = doc(this.firestore,'favorite')
      let data = {
        quizId: quizId,
        userId: userContentRef.refUserId,
        creationDate: serverTimestamp()
      }
      let docRef = doc(this.firestore, 'favorite', this.helperService.uuidv4())
        setDoc(docRef, data)
      // console.log('service side add',true)
      resolve(true)
    })
  }

  //delete favorite quizs
  isDeleteFavoriteQuiz(quizId: any) {
    return new Promise((resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      let quizRef = collection(this.firestore, 'favorite')
      let queryRef: any;
      if (quizId) {
        queryRef = query(quizRef, where('quizId', '==', quizId), where('userId', '==', userContentRef.refUserId));
      }
      getDocs(queryRef).then((result: any) => {
        if (result) {
          result.forEach((element: any) => {
            deleteDoc(doc(quizRef, element.id))
          });
          resolve(false)
        }
      }).catch((err)=>{
        reject(err)
      })
    })
  }

  //check quizs
  checkIsF(quizId: any) {
    return new Promise((resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      let quizRef = collection(this.firestore, 'favorite')
      let queryRef: any;
      if (quizId) {
        queryRef = query(quizRef, where('quizId', '==', quizId), where('userId', '==', userContentRef.refUserId));
      }
      let isFavorate: any;
      getDocs(queryRef).then((doc: any) => {
        doc.forEach((element: any) => {
          let favoriteQuiz = element.data()
          isFavorate = true;
        });
        resolve(isFavorate)
      }).catch((err) => {
        reject(err)
      })
    })
  }

  // //get favorite quizId
  //   getFavoriteQuizs(quizId:any){
  //     // console.log("quizId:",quizId)
  //     return new Promise((resolve,reject)=>{
  //       let userContentRef = this.userService.getUserContentRef()
  //       let quizRef = collection(this.firestore,'favorite')
  //       let queryRef:any ;
  //       queryRef = query(quizRef,where('userId', '==', userContentRef.refUserId),orderBy('creationDate','desc'));
  //       let favoriteQuiz:any=[];
  //       getDocs(queryRef).then((doc:any) => {
  //         doc.forEach((element:any) => {
  //           let fQuiz = element.data().quizId
  //           favoriteQuiz.push(fQuiz)
  //         });
  //         // console.log(favoriteQuiz)
  //         resolve(favoriteQuiz)
  //       }).catch((err) => {
  //         reject(err)
  //       })
  //     })
  //   }
  getFavoriteQuizs(quizId: any) {
    return new Promise((resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      let queryRef: any;
      if (quizId.length == 0) {
        queryRef = query(collection(this.firestore, 'favorite',), where('userId', '==', userContentRef.refUserId), orderBy('creationDate', 'desc'), limit(10));
      }
      else {
        var lastDoc = quizId[quizId.length - 1];
        queryRef = query(collection(this.firestore, 'favorite',), where('userId', '==', userContentRef.refUserId), orderBy('creationDate', 'desc'), startAfter(lastDoc['creationDate']), limit(10));
      }
      getDocs(queryRef).then((docs) => {
        resolve(docs)
      }).catch((err) => {
        reject(err)
      })
    })
  }


  // get quizs
  getFavoriteQuizDetailsById(quizId: any) {
    let userContentRef = this.userService.getUserContentRef();
    return new Promise((resolve, reject) => {
      var getFavoriteQuizs: any = [];
      let queryRef = query(
        collection(this.firestore, 'contentAccountMapping', userContentRef.contentId, 'quiz',), where("quizId", "in", quizId));
      getDocs(queryRef).then((docs) => {
        docs.forEach((doc) => {
          let fQuiz = doc.data()
          getFavoriteQuizs.push(fQuiz)
        });
        resolve(getFavoriteQuizs);
      })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //--------------------End favorite quiz-------------------------------

  getQuizIdsFromBigQuery(data: any) {
    // return new Promise((resolve, reject) => {
    //   let body: any = {
    //     accountId: data.accountId,
    //     fromDate: data.fromDate,
    //     toDate: data.toDate
    //   }
    //   this.http.post<any>(environment.curiosity + '/api/quiz/tranding-quiz', body).subscribe({
    //     next: data => {
    //       resolve(data)
    //     },
    //     error: error => {
    //       resolve([])
    //       console.error('There was an error!', error);
    //     }
    //   })
    // })
  }

  checkQuizName(quizId: any, accountId: any, quizName: any) {
    return new Promise(async (resolve, reject) => {
      try {
        const quizRef = query(collectionGroup(this.firestore, 'quiz'), where('refAccountId', '==', accountId), where('quizId', '!=', quizId), where("quizName", "==", quizName), where('quizStatus', '==', "p"));
        const querySnapshot = await getDocs(quizRef);
        if (querySnapshot.docs.length != 0) {
          resolve(true);
        } else {
          resolve(false);
        }
      } catch (error) {
        reject(error)
      }
    })
  }

  // get Product detail
  getProductDetail(projectId: any) {
    return new Promise((resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef();
      if (!projectId)
        reject(null);
      var getProductData: any = [];
      let queryRef = query(
        collection(this.firestore, 'contentAccountMapping', userContentRef.contentId, 'quiz', projectId, 'product'), where("productId", "==", projectId));
      getDocs(queryRef).then((docs) => {
        docs.forEach((doc) => {
          let productData = doc.data()
          getProductData.push(productData)
        });
        resolve(getProductData);
      })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // add product detail
  async addProductDetail(projectId: any, product: any) {
    return new Promise(async (resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      if (!projectId)
        reject(null);
      let Productdata = {
        ...product,
        productId: projectId
      }
      let ProductRef = doc(this.firestore, 'contentAccountMapping', userContentRef.contentId, 'quiz', projectId, 'product', projectId)
      setDoc(ProductRef, Productdata).then((result) => {
        resolve(true);
      }).catch((err) => {
        reject(err);
      });
    })
  }

  createContributors(contributors: any) {
    return new Promise((resolve, reject) => {
      let projectRef = doc(this.firestore, 'contentAccountMapping', contributors.contentId, 'contributors', contributors.quizId);
      setDoc(projectRef, contributors).then((result) => {
        resolve(contributors);
      }).catch((err) => {
        reject(err);
      });
    })
  }

  getContributors(uid: any) {
    return new Promise(async (resolve, reject) => {

      let quizRef = collection(this.firestore, 'contentAccountMapping', uid, 'contributors');
      let querySnapshot = await getDocs(quizRef)
      let contributors: any = []
      querySnapshot.forEach((doc) => {
        //  let date =doc.data().creationDate;
        let data: any = {}

        data = doc.data();
        let timestamp
        if (data.creationDate) {
          timestamp = data.creationDate.toDate()
          let date = new Date(timestamp)

          let date1 = date.getDate() +
            "-" + (date.getMonth() + 1) +           //CONVERTING THE TIMESTAMP TO DATE FORMATE
            "-" + date.getFullYear() + "  at " + date.getHours() + " : " + date.getMinutes() + " minutes "
          data['date'] = date1
          // this.contributors.push(data1)
        }
        contributors.push(data);

      });
      resolve(contributors)
    }).catch((err) => {
      console.log(err)
      // resolve([])
    })
  }

  getOneContributorsbyQuizID(uid: any, quizId: any) {
    return new Promise(async (resolve, reject) => {
      let quizRef = doc(this.firestore, 'contentAccountMapping', uid, 'contributors', quizId)
      getDoc(quizRef).then((doc) => {
        let ContriDetails = doc.data();
        resolve(ContriDetails)
      }).catch((err: any) => {
        reject(err)
      })

    })
  }

  // =====upload quiz csv==========

  uploadQUizByCsv(quizUploadDetails: any) {
    return new Promise((resolve, reject) => {
      let projectRef = doc(this.firestore, 'contentAccountMapping', quizUploadDetails.contentId, 'quiz', quizUploadDetails.quizId);
      setDoc(projectRef, quizUploadDetails).then((result) => {
        resolve(quizUploadDetails);
      }).catch((err) => {
        reject(err);
      });
    })
  }

  //  =============urls======
  addInUrl(quizId: any, pollId = null, pollType: any, data: any) {
    return new Promise(async (resolve, reject) => {
      let quizRef: any
      if (pollId == null) {
        quizRef = query(collection(this.firestore, 'urls'), where("quizId", "==", quizId))
      } else {
        quizRef = query(collection(this.firestore, 'urls'), where("pollId", "==", pollId))
      }

      let urlid: any
      let quiz: any
      let querysnap = await getDocs(quizRef)
      querysnap.forEach((doc) => {
        // console.log("doc", doc.data())
        let url: any = doc.data()
        urlid = url.urlId
        quiz = url.quizId
      });
      if (urlid && quiz) {
        let queryRef: any = doc(this.firestore, 'urls', urlid)
        setDoc(queryRef, data, { merge: true }).then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        });
      } else {
        let data1: any = {
          // shareDatePoll:serverTimestamp(),
          sharedOn: data.sharedOn
        }

        if (pollType == "ht") {
          data1['shareDatePollht'] = serverTimestamp()
        } else {
          data1['shareDatePoll'] = serverTimestamp()
        }

        let queryRef: any = doc(this.firestore, 'urls', urlid)
        setDoc(queryRef, data1, { merge: true }).then((result) => {
          resolve(result);
        }).catch((err) => {
          reject(err);
        });

      }
    })
  }
  // get contentAccountMapping details (collaborator)
  public contentAccountMappingDetails(userId: string) {
    return new Promise(async (resolve, reject) => {
      let docRef = doc(this.firestore, 'contentAccountMapping', userId);
      getDoc(docRef).then((doc) => {
        let contentAccountMappingDetails: any;
        contentAccountMappingDetails = doc.data();
        resolve(contentAccountMappingDetails)
      }).catch(err => {
        reject(err)
      })
    })
  }
  // delete contentAccountMapping document (collaborator) only quizStatus update
  deleteContentAccountMapping(userId: any, quiz: any) {
    return new Promise((resolve, reject) => {
      let queryRef: any = doc(this.firestore, 'contentAccountMapping', userId, "quiz", quiz.quizId)
      quiz['quizStatus'] = 't'
      setDoc(queryRef, quiz, { merge: true }).then((result) => {
        this.getAllQuestionStatsByProjectId(userId, quiz.quizId).then((ress: any) => {
          resolve(true)
        })
        // resolve(true)
      }).catch(err => {
        reject(err)
      })
    })
  }
  //get questions by quizId for deletion quistions (collaborator) only questionStatus update
  public async getAllQuestionStatsByProjectId(userId: any, quizId: string) {
    return new Promise((resolve, reject) => {
      let statsRef: any = collection(this.firestore, 'contentAccountMapping', userId, "quiz", quizId, 'question');
      getDocs(statsRef).then((results) => {
        if (!results.empty) {
          results.docs.forEach((docref) => {
            let q: any = docref.data();
            let statsRef1 = doc(this.firestore, 'contentAccountMapping', userId, "quiz", quizId, 'question', q.questionId)
            deleteDoc(statsRef1)
            q['questionStatus'] = 't'
            setDoc(statsRef1, q, { merge: true }).then((result) => {
            })
          });
        }
        resolve(true);
      }, error => reject(error));
    });
  }


  // ======================for merge functions ==========================
  // (also we are using for link quiz)

  storeDetailsForMerge(quizId: any, isChecked: any, quizName: any , contentId:any, description:any, coverImgUrl:any ) { //this functions stores the id of quizzes which user  have selected 
    if (isChecked) {
      this.mergeQuizMap[`${quizId}`] = { quizName, checked: true , contentId, description, coverImgUrl };
    } else {
      delete this.mergeQuizMap[quizId];
    }
    // console.log("merge quiz mapp ", this.mergeQuizMap)

    this.mergeQuizMapSubject.next(this.mergeQuizMap);
  }
  emptyMergeMap() {
    this.mergeQuizMap = {}
  }
  getMergeMapData() {
    return this.mergeQuizMap;
  }


  //============================ Delete  Quiz permanent===============================

    deleteQuizPermanently(quizId:any,contentId:any) {
      return new Promise((resolve, reject) => {
        let docRef =doc(this.firestore,'contentAccountMapping',contentId,'quiz',quizId)
        deleteDoc(docRef).then(result => {
          resolve(true)
        }).catch(err => {
          reject(err)
        })
      })
  }

  // ==========example lib================ 
  public getQuizsForExampleLibByTemplateId(templateId: any,all:any = null) {
  return new Promise((resolve, reject) => {
      var getQuizsData: any = [];
      let queryRef:any
      if(!all){
        queryRef = query(collectionGroup(this.firestore, 'quiz'), where("isTemplateSampleQuiz", "==", 'p'), where("refTemplateId", "==", templateId),where("quizStatus", "!=", 't'));
      }else{
        queryRef = query(collectionGroup(this.firestore, 'quiz'), where("isTemplateSampleQuiz", "==", 'p'),where("quizStatus", "!=", 't'));
      }
      getDocs(queryRef).then((docs) => {
        docs.forEach((doc) => {
          let QuizsData:any = doc.data()
          // if(QuizsData.quizStatus == 'p')
          if(QuizsData.isTemplateSampleQuiz){
            getQuizsData.push(QuizsData)
          }
        });
        resolve(getQuizsData);
      }).catch((err) => {
          reject(err);
        });
    });
  }

  getNonLiveDetailsByPin(pin:any){
    return new Promise((resolve, reject) => {
      const nonLiveDrsQueryRef = query(collection(this.firestore, 'nonLiveDrs'), where('nonLivePin', '==', pin))
      getDocs(nonLiveDrsQueryRef).then((querySnapshot) => {
        let nonLiveDrsData:any = {}
        querySnapshot.forEach((doc) => {
          nonLiveDrsData = { id: doc.id, ...doc.data() }
        })
        resolve(nonLiveDrsData)
      }).catch((err:any) => {
        reject(err)
      })
    })
  }

// get quiz details for questionsForReaders
  // public getQuizDetailsByOnlyQuizId(quizId: any) {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       let quizs: any = {};
  //       let quizRef: any;
  //       quizRef = query(collectionGroup(this.firestore, 'quiz'), where("quizId", "==", quizId), where('quizStatus', '==', 'p'), limit(1));
  //       const querySnapshot = await getDocs(quizRef);
  //       querySnapshot.forEach((doc) => {
  //         let quizDetails: any;
  //         quizDetails = doc.data();
  //         quizDetails.quizId = doc.id;
  //         quizs = quizDetails
  //       });
  //       resolve(quizs)
  //     } catch (error) {
  //       reject(error)
  //     }
  //   })
  // }

  
  // get quiz details for questionsForReaders
  public getQuizDetailsByOnlyQuizId(quizId: any, webPageId: any = null) {
    return new Promise(async (resolve, reject) => {
      try {
        let quizs: any = {};
        let quizRef: any;
        if (webPageId) {
          quizRef = query(collectionGroup(this.firestore, 'quiz'), where("webPageId", "==", webPageId), where('quizStatus', '==', 'p'), limit(1));
        } else {
          quizRef = query(collectionGroup(this.firestore, 'quiz'), where("quizId", "==", quizId), where('quizStatus', '==', 'p'), limit(1));
        }
        const querySnapshot = await getDocs(quizRef);
        querySnapshot.forEach((doc) => {
          let quizDetails: any;
          quizDetails = doc.data();
          quizDetails.quizId = doc.id;
          quizs = quizDetails
        });
        resolve(quizs)
      } catch (error) {
        reject(error)
      }
    })
  }

  getQuizDetailsForContest(contestQuizzes:any){
    return new Promise(async (resolve, reject) => {
      try {
        let quizRef: any;
        let quizs:any[] = [{}]
        contestQuizzes.forEach(async (quiz:any) => {
          // console.log(quiz)
          let quizRef = doc(this.firestore, 'contentAccountMapping', quiz.contentId, 'quiz', quiz.id)
          getDoc(quizRef).then((doc) => {
            let quizDetail:any = doc.data()
            quizDetail.id = doc.id;
            quizDetail['contestDT'] = quiz
            // console.log(quizDetail)
            quizs.push(quizDetail)
          })
        })
        resolve(quizs)
      } catch (error) {
        reject(error)
      }
    })
  }

  //for share-pdf and update questionsForReaders (display questions for readers in seprate webpage)
  public updateQuizForReaders(quizDetails: any,questionsForReaders:any) {
    return new Promise((resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      const updatedOn = serverTimestamp();
      const updatedBy = getAuth().currentUser?.uid;
      quizDetails.updatedOn = updatedOn;
      if (updatedBy) {
        quizDetails.updatedBy = updatedBy;
        quizDetails.questionsForReaders = questionsForReaders
      }
      let docRef = doc(this.firestore, 'contentAccountMapping', userContentRef.contentId, "quiz", quizDetails.quizId);
      updateDoc(docRef, {questionsForReaders,updatedBy}).then(() => {
        resolve(quizDetails)
      }).catch((err)=>{
        reject(err)
      })
    })
  }
  public updateQuizForPdf(quizDetails: any) {
    return new Promise((resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      const dateTimeLatestGeneratedPDF = serverTimestamp();
      const updatedBy = getAuth().currentUser?.uid;
      quizDetails.dateTimeLatestGeneratedPDF = dateTimeLatestGeneratedPDF;
      let docRef = doc(this.firestore, 'contentAccountMapping', userContentRef.contentId, "quiz", quizDetails.quizId);
      updateDoc(docRef, {dateTimeLatestGeneratedPDF,updatedBy}).then(() => {
        resolve(quizDetails)
      }).catch((err)=>{
        reject(err)
      })
    })
  }
  setPdfLetestDT(dt:any){
    this.pdfLetestDT = dt
  }
  getPdfLetestDT(){
    return this.pdfLetestDT
  }


  /**
 * This function retrieves player details from the 'instances' collection
 * based on the provided 'buzzerQuizId'. It uses 'getDocs' to fetch the
 * documents and returns a Promise that resolves with the player list.
 * @param {string} buzzerQuizId - The ID of the buzzer quiz
 * @return {Promise<Array<Object>>} - A Promise that resolves with an array of
 * player objects
 */
  getBuzzerPlayerDetails = async (buzzerQuizId: any) => { 
    try {
      const querySnapshot = await getDocs(query(collection(this.firestore, 'instances'), where('buzzerQuizId', '==', buzzerQuizId)))
      return querySnapshot.docs.map(doc => doc.data())
    } catch (err) {
      throw err
    }
  }
   // getting buzzer quiz list
  getBuzzerQuizDetails(refQuizId: any) {
    let buzzerQuizList: any = [];
    return new Promise((resolve, reject) => {
      const buzzerDrsQueryRef = query(collection(this.firestore, 'buzzerQuiz'), where('refQuizId', '==', refQuizId));
      getDocs(buzzerDrsQueryRef).then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          buzzerQuizList.push(doc.data());
        });
        resolve(buzzerQuizList);
      }).catch((err: any) => {
        reject(err);
      });
    });
  }


// link quiz: get contestList
  getCreatedContestList() {
    let contestList: any = [];
    let userContentRef = this.userService.getUserContentRef()
    return new Promise((resolve, reject) => {
      const contestListQueryRef = query(collection(this.firestore, 'quizChain'), where('accountId', '==', userContentRef.refAccountId), where('contentId','==',userContentRef.contentId));
      getDocs(contestListQueryRef).then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let data:any = doc.data()
          if(data?.status != 't'){
            contestList.push(doc.data());
          }
        });
        resolve(contestList);
      }).catch((err: any) => {
        reject(err);
      });
    });
  }

//link quiz : get contest player username password list form quizInvitation
  getContestPlayerInvitationDetailsByContestId(contestId:any,uploadPlayerUsernamePassword:any=null) {
    return new Promise((resolve, reject) => {
      let quizInvitationData:any = [];
      let quizInvitationRef:any = query(collection(this.firestore,'quizInvitation'),where("contestId", "==", contestId),orderBy("createdOn", "asc"),)
      getDocs(quizInvitationRef).then((docs) => {
        docs.forEach((doc) => {
          let _data:any = doc.data()
          // console.log(_data)

          // check for username password registeration
          if(uploadPlayerUsernamePassword && _data.usernamePassword && !_data.isDeleted){
            quizInvitationData.push(_data)

            // check for approved player registration
          }else if(!uploadPlayerUsernamePassword && _data.email && !_data.isDeleted){
            quizInvitationData.push(_data)
          }
          
        });
        resolve(quizInvitationData);
      }).catch((err) => {
        reject(err);
      });
    });
  }


// save link quiz data
  saveQuizLinkDetails(linkQuizObject:any){
    return new Promise((resolve, reject) => {
      let linkQuizRef = doc(this.firestore, 'quizChain', linkQuizObject.contestId)
      setDoc(linkQuizRef, linkQuizObject, {merge:true}).then((result) => {
        resolve(true)
      }).catch(err => {
        reject(err)
      })
    })
  }

  getCreatedContestDetailBycontestId(contestId:any) {
    let contestDetail: any;
    return new Promise(async (resolve, reject) => {
      let docRef = doc(this.firestore, 'quizChain', contestId);
      getDoc(docRef).then((doc) => {
        contestDetail = doc.data();
        resolve(contestDetail)
      }).catch(err => {
        reject(err)
      })
    })
  }

  getContestByContestId(contestId:any){
    return new Promise((resolve,reject)=>{
      let ref =doc(this.firestore,'quizChain',contestId)
      getDoc(ref).then(doc=>{
        let contest = doc.data()
        resolve(contest)
      }).catch(err=>{
        reject(err)
      })
    })
  }

  // contest reg player details added for validation
  contestRegistrationData(contestLoginData:any){
    return new Promise((resolve, reject) => {
      // console.log(contestLoginData)
      let data:any = {
        ...contestLoginData,
        creationDate:serverTimestamp(),
        isRegistered :true,
        id:this.helperService.uuidv4()
      }
      // console.log(data)
      let linkQuizRef = doc(this.firestore, 'contestInvitation', data.id)
      setDoc(linkQuizRef, data, {merge:true}).then((result) => {
        resolve(true)
      }).catch(err => {
        reject(err)
      })
    })
  }

  // using for quiz invitation link
  getRecipientDetails(distributionId:any,recipientId:any){
      return new Promise(async (resolve, reject) => {
      let quizRef = doc(this.firestore, 'distribution', distributionId, 'recipient', recipientId)
      getDoc(quizRef).then((doc) => {
        let ContriDetails = doc.data();
        resolve(ContriDetails)
      }).catch((err: any) => {
        reject(err)
      })
    })
  }

  // /quiz chain ======
  
  getChainByquizId(quizId:string) {
    return new Promise((resolve, reject) => {
      const collectionRef = collection(this.firestore,'quizChain')
      const queryRef = query(collectionRef, where('chainStatus', '==', 'a'), where('nodes', 'array-contains', quizId), limit(1));
      let quizChain:any = []
      getDocs(queryRef)
        .then((docs) => {
          docs.forEach((doc) => {
            let chainData = doc.data();
            quizChain.push(chainData);
          });
          resolve(quizChain[0]);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
